// import {getFoundersOrRegionsInfo, getKcpGroups} from "@/api/spr";
// import {getContacts} from "@/api/contacts";
import { getSpr } from '@/API/spr';
import store from '@/newApplication/store';

export default {
  namespaced: true,
  state: {
    // founders: [],
    // foundersLoading: false,
    predmets: [],
    predmetsLoading: false,
    predmetsError: null,
    org: [],
    orgLoading: false,
    orgError: null,
    kcpgroup: [],
    kcpgroupLoading: false,
    kcpgroupError: null,
    fo: [],
    foLoading: false,
    foError: null,
    usl: [],
    uslLoading: false,
    uslError: null,
    ff: [],
    ffLoading: false,
    ffError: null,
    spec: [],
    specLoading: false,
    specError: null,
  },
  mutations: {
    ['LOADING_STATUS'](state, payload) {
      state[payload.name + 'Loading'] = payload.value;
    },
    ['ERROR_STATUS'](state, payload) {
      state[payload.name + 'Error'] = payload.value;
    },
    ['CHANGE_VALUE'](state, payload) {
      state[payload.name] = payload.value;
    },
  },
  actions: {
    async downloadSprData({ commit }) {
      /*${rootGetters['keycloak/getOrgId']}*/
      let year = '2024';
      if (store.getters.selectedYear) year = store.getters.selectedYear;
      const apiInfo = [
        { name: 'predmets', api: 'spr/eduSubjects' },
        { name: 'org', api: 'spr/org' }, // /org/?ownerId=${this.getUser.orgID}`
        { name: 'kcpgroup', api: 'spr/kcpgroup' },
        { name: 'fo', api: 'spr/fo' },
        { name: 'usl', api: 'spr/usl' },
        { name: 'ff', api: 'spr/ff' },
        { name: 'spec', api: 'spr/spec' },
      ];
      apiInfo.forEach((el) => commit('LOADING_STATUS', { name: `${el.name}`, value: true }));
      const requests = apiInfo.map(async (el) => await getSpr(el.api, el.name, year));
      Promise.allSettled(requests)
        .then((x) => {
          x.forEach((el) => {
            if (!(el instanceof Error))
              commit('CHANGE_VALUE', { name: `${el.value.name}`, value: el.value.value });
            else commit('ERROR_STATUS', { name: `${el.reason?.message}`, value: 'error' });
            commit('LOADING_STATUS', { name: `${el.value.name}`, value: false });
          });
        })
        .catch((e) => {
          if (Array.isArray(e))
            e.forEach((el) => {
              commit('ERROR_STATUS', { name: `${el}`, value: 'error' });
              commit('LOADING_STATUS', { name: `${el}`, value: false });
            });
          else {
            commit('ERROR_STATUS', { name: `${e}`, value: 'error' });
            commit('LOADING_STATUS', { name: `${e}`, value: false });
          }
        });
    },
  },
  getters: {
    getSprData(state) {
      return {
        org: state.org,
        predmets: state.predmets,
        kcpgroup: state.kcpgroup,
        fo: state.fo,
        usl: state.usl,
        ff: state.ff,
        spec: state.spec,
      };
    },
    getSprDataLoading(state) {
      return {
        org: state.orgLoading,
        predmets: state.predmetsLoading,
        kcpgroup: state.kcpgroupLoading,
        fo: state.foLoading,
        usl: state.uslLoading,
        ff: state.ffLoading,
        spec: state.specLoading,
      };
    },
    getSprDataError(state) {
      return {
        org: state.orgError,
        predmets: state.predmetsError,
        kcpgroup: state.kcpgroupError,
        fo: state.foError,
        usl: state.uslError,
        ff: state.ffError,
        spec: state.specError,
      };
    },
    // getFounders: state => {
    //     return state.founders;
    // },
    // getFoundersStatus: state => {
    //     return state.foundersLoading;
    // },
    // getRegions: state => {
    //     return state.regions;
    // },
    // getRegionsStatus: state => {
    //     return state.regionsLoading;
    // },
    // getKcpGroups: (state, _, __, rootGetters) => {
    //     const id = rootGetters['keycloak/getAuthData']?.founderID ?? rootGetters['keycloak/getFakeUser']?.id;
    //     const ugsList = state.founders.find(el => el?.id === id)?.coUgsList;
    //     const ugsListIds = ugsList?.map(el => el.ugsId);
    //     return state.kcpGroups.filter(el => ugsListIds?.includes(el.ugs?.id) || !id).map(el => {
    //         return {...el, isMain: ugsList?.find(el2 => el2.ugsId === el?.ugs?.id)?.isMain ?? false}
    //     });
    // },
    // getKcpGroupsStatus: state => {
    //     return state.kcpGroupsLoading;
    // },
  },
};
